import { RefObject, createContext, useContext } from 'react';

type CardContextContent = {
    cardRef: RefObject<HTMLDivElement | null>;
    onRemove?: (item: Material) => void;
};

const CardContext = createContext<CardContextContent>({ cardRef: { current: null } });

export const useCardContext = () => useContext(CardContext);

export default CardContext;
